import { Flex, Link, Text, TextLabel } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
// import React, { useCallback } from 'react';
import { ApiData } from './types';

const TokenTable = ({
  apiData,
  handleClickEdit,
}: {
  apiData: ApiData;
  handleClickEdit: (value: ApiData) => void;
}) => {
  const { t } = useTranslation('administration');

  return (
    <Flex direction="column">
      <Text>
        <Link
          width="100%"
          onClick={() => {
            handleClickEdit(apiData);
          }}
        >
          {apiData.name}
        </Link>
      </Text>
      <Text>{apiData.description}</Text>
      <TextLabel mt="15px">
        <strong>{t('administration.apiToken.table.token.title')}:</strong>
        {apiData.accessToken}
      </TextLabel>
    </Flex>
  );
};

export default TokenTable;
